import React from 'react';
import { Modal, Button } from 'react-bootstrap'; // Using react-bootstrap modals as is common
import { Link } from 'react-router-dom';

const UpgradeModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Upgrade Your Plan</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p>This feature is available on paid plans.</p>
        <p>Please upgrade your plan.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Maybe Later
        </Button>
        {/* This Link should go to your subscription/pricing page */}
        <Link to="/subscriptionplans" className="btn btn-primary">
          View Plans
        </Link>
      </Modal.Footer>
    </Modal>
  );
};

export default UpgradeModal;